import api from './api';

const API_GATEWAY_URL_PROMO = process.env.API_GATEWAY_URL_PROMO;

const getPromoHero = (payload) => {
  const params = new URLSearchParams(payload).toString();
  return api.get(`promo/v1/promo/hero${params ? `?${params}` : ''}`, {}, false, false, false);
};

const getPromoList = (
  {
    category = '',
    page = 0,
    size,
  }: {
    category?: string;
    page?: number;
    size: number;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo/national?content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoBySlug = (slugName: string, isUseGatewayAPI?: boolean) =>
  api.get(
    `promo/v1/promo/slug/${slugName}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );

const getPromoBySlugWithArticleType = (
  {
    slug = '',
    articleType = '',
    objectCode = '',
  }: {
    slug?: string;
    articleType?: string;
    objectCode?: string;
  },
  isUseGatewayAPI?: boolean
) =>
  api.get(
    `promo/v1/promo/slug/${encodeURIComponent(slug)}`,
    isUseGatewayAPI
      ? {
          baseURL: API_GATEWAY_URL_PROMO,
          params: {
            articleType,
            objectCode,
          },
        }
      : {
          params: {
            articleType,
            objectCode,
          },
        },
    false,
    false,
    false
  );

// Get Promo national navbar geoLocation
const getPromoNational = (payload: { page: number; size: number }, isUseGatewayAPI?: boolean) => {
  return api.get(
    `promo/v1/promo/national?page=${payload.page}&size=${payload.size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : null,
    Boolean(payload)
  );
};

const getPromoListByCategory = (
  {
    category,
    page = 0,
    size,
  }: {
    category: string;
    page?: number;
    size: number;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo?content-category=${encodeURIComponent(category)}&page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getAnotherPromo = (isUseGatewayAPI?) => {
  const size = 4;
  return api.get(
    `promo/v1/promo?page=${0}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoListByCity = (
  {
    isocode = '',
    page = 0,
    size = 4,
    category = '',
    isLandingPage = '',
  }: {
    isocode?: string;
    page?: number;
    size?: number;
    category?: string;
    isLandingPage?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo?city=${isocode}&content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoListByBranch = (
  {
    branch = '',
    page = 0,
    size = 4,
    category = '',
    isLandingPage = '',
  }: {
    branch?: string;
    page?: number;
    size?: number;
    category?: string;
    isLandingPage?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo?content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}&branchSlug=${branch}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoListBySalesman = (
  {
    branchSlug = '',
    salesmanSlug = '',
    page = 0,
    size = 4,
    isLandingPage = '',
  }: {
    branchSlug?: string;
    salesmanSlug?: string;
    page?: number;
    size?: number;
    isLandingPage?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo/salesman/${encodeURIComponent(
      salesmanSlug
    )}?page=${page}&size=${size}&isLandingPage=${isLandingPage}&branchSlug=${branchSlug}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoListByProductCode = (
  {
    productCode = '',
    page = 0,
    size = 4,
    type = '',
  }: {
    productCode?: string;
    page?: number;
    size?: number;
    type?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `promo/v1/promo?productCode=${encodeURIComponent(productCode)}&page=${page}&size=${size}&type=${type}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

const getPromoHeroV2 = (
  payload: string[][] | Record<string, string> | string | URLSearchParams,
  isUseGatewayAPI?: boolean
) => {
  // contentCategory Value
  //  all: 'all',
  //  mobil-baru: 'mobil-baru',
  //  servis: 'service',
  //  lainnya: 'lainnya',
  const params = new URLSearchParams(payload).toString();
  return api.get(
    `promo/v2/promo/hero${params ? `?${params}` : ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PROMO } : {},
    false,
    false,
    false
  );
};

export default {
  getPromoHero,
  getPromoList,
  getPromoNational,
  getPromoBySlug,
  getPromoListByCategory,
  getAnotherPromo,
  getPromoListByCity,
  getPromoListByBranch,
  getPromoListBySalesman,
  getPromoListByProductCode,
  getPromoBySlugWithArticleType,
  getPromoHeroV2,
};
